import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';

import { AppProvider } from 'Providers';
import App from './App';

import './index.scss';

const init = async () => {
  // <-- local development -->
  // IMPORTANT!!! Uncomment this if you want to work with production billing api in local dev
  // token is your production api token
  // also set regions.us-east-1.web_api_url in public/configurations/development.json to be 'https://api.bringg.com'
  // make sure you are avoid CORS errors
  // const token = '';
  // authentication.storeCredentials(token, 'us-east-1', 'en');
  // await rootStore.uiStore.authStore.initSdkFromLocalEnvironment();
  // <-- local development -->

  ReactDOM.render(
    <React.StrictMode>
      <HashRouter>
        <AppProvider>
          <App />
        </AppProvider>
      </HashRouter>
    </React.StrictMode>,
    document.getElementById('root')
  );
};

init();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
